module.exports = __webpack_public_path__ + "static/bootstrap-theme-fb3bd08da0da2b7a43c555df07bfa454.png";